import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Source, Layer } from 'react-mapbox-gl'
import ChartActions from '../redux/chartRedux'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
// import BuoyImage from '../assets/simpleBuoy.svg'
import { svg } from '../assets/buoySprite'

// const layoutLayer = { 'icon-image': 'londonCycle' }
const image = new Image()
image.src = 'data:image/svg+xml;charset=utf-8,' + svg
// const images = ['londonCycle', image]

export const BUOYS = token =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ASmartIceBuoyFeatures&token=${token}`

const id = 'Buoys'
const authId = 'SmartIce'
const sourceLayer = 'Buoys'

class Buoys extends Component {
  static contextTypes = {
    map: PropTypes.object
  }
  
    componentDidMount () {
    const { map } = this.context
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('click', id, this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('click', id, this.handleClick)
  }
  
  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    
    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context

    map.getCanvas().style.cursor = ''
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const { features } = event
    if (features.length > 0) {
      // actions.streetviewAdded(event.lngLat)
    }
  }
  render () {
    const { idToken, layerRendered, paint } = this.props
    const visible = layerRendered

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source
          id={id}
          geoJsonSource={{
            type: 'geojson',
            data: BUOYS(idToken)
          }}
        />
        <Layer
          type='circle'
          id={id}
          sourceId={id}
          paint={paint}
          // layout={layoutLayer}
          // images={images}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layersRendered: state.layer.layersRendered,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id)
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      chartPanelToggled: () => dispatch(ChartActions.chartPanelToggled())
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(Buoys)



// WEBPACK FOOTER //
// ./src/layers/Buoys.js